import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { DIGITAL_JOURNEY_BASE_URL } from '../apiConfig'

export const fetchFieldMaster = createAsyncThunk(
    'fetchFieldMaster',
    async ({ jwtBearer }) => {
        const response = await fetch(`${DIGITAL_JOURNEY_BASE_URL}portal/get/fields/master/data/`, {
            headers: {
                Authorization: `Bearer ${jwtBearer}` // Include the bearer token in the request header
            }
        })
        return response.json()
    }
)

const fieldMasterDataSlice = createSlice({
    name: 'fieldMasterDataSlice',
    initialState: {
        isLoading: false,
        data: null,
        isError: false
    },
    extraReducers: builder => {
        builder.addCase(fetchFieldMasterData.pending, (state, action) => {
            state.isLoading = true
        })
        builder.addCase(fetchFieldMasterData.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        })
        builder.addCase(fetchFieldMasterData.rejected, (state, action) => {
            console.log('Error', action.payload)
            state.isError = true
        })
    }
})

export default fieldMasterDataSlice.reducer
